import axiosInstance from '../axiosInstance.js'

export default {
  postReset(email) {
    return axiosInstance.post(
      `${import.meta.env.VITE_WELCOME_API_URL}/reset-password/requests`,
      {
        email: email
      }
    )
  },
  postResetNewPassword({ token, password, passwordRepeat }) {
    return axiosInstance.post(
      `${import.meta.env.VITE_WELCOME_API_URL}/reset-password/confirms`,
      JSON.stringify({
        token: token,
        newPassword: password,
        repeatNewPassword: passwordRepeat
      })
    )
  }
}
